import { DEFAULTS } from '@/constants';
import { MatcherTaskVersion } from '@/constants/task';

/**
 * @param {'protected_link' | 'mig_pal_link'} linkType
 * @param {string} resultId
 * @param {string} matcherVersion
 */
const getCustomerLinkPath = (
  linkType,
  resultId,
  matcherVersion = MatcherTaskVersion.V1
) =>
  linkType === DEFAULTS.LINKS_TYPES_MAP.CUSTOMER_LINK
    ? `customer/${matcherVersion}/processing-results/${resultId}`
    : `customer/${matcherVersion}/migration/${resultId}/dashboard`;

/**
 * @param {string} resultId
 * @param {'protected_link' | 'mig_pal_link'} linkType
 * @param {string} accessToken
 * @param {string} matcherVersion
 */
export const generateCustomerLink = (
  resultId,
  linkType,
  accessToken,
  matcherVersion
) => {
  const linkPath = getCustomerLinkPath(linkType, resultId, matcherVersion);
  return `${window.location.protocol}//${window.location.host}/${linkPath}?access_token=${accessToken}`;
};
